import { render } from "./SidebarSection.vue?vue&type=template&id=40cc14aa&ts=true"
import script from "./SidebarSection.vue?vue&type=script&lang=ts"
export * from "./SidebarSection.vue?vue&type=script&lang=ts"

import "./SidebarSection.vue?vue&type=style&index=0&id=40cc14aa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__